import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { I18nextProvider } from 'react-i18next';
import i18n from './localization/i18n'
import Store, { history } from './store';
import Routes from './routes';

/**
  * App version 2022-07-10
  * App Master, App update
  * 
  * App version 2021-07-10
  * App Staging, update fix tracking
  * 
  * App version 2022-07-10
  * App Dev, update new monitoring data without segment 
  * */ 

const store = Store();

const App = () => (
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Routes/>
            </ConnectedRouter>
        </Provider>
    </I18nextProvider>
);

export default App;
